import { render, staticRenderFns } from "./dialog-quick-bulk-message.vue?vue&type=template&id=f9daaed0&scoped=true&"
import script from "./dialog-quick-bulk-message.vue?vue&type=script&lang=js&"
export * from "./dialog-quick-bulk-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9daaed0",
  null
  
)

export default component.exports